const data = () => {
    return {
        loading: false,
        indexTabActive: +localStorage.getItem('MONITOR-TAB-ACTIVE') || 0,
        tabsKey: 0,
        productsMissmatch: [],
        accountsMissmatch: [],
        dailySummary: [],
        // Campos que se muestran arriba del Monitor de descuadres
        fieldsResume: [],
        resume: null, // Información obtenida desde la actualización de RD
        tabsAccount: JSON.parse(localStorage.getItem('MONITOR-TABS')) || []
        // Cuentas abiertas por el usuario y que se mostrarán en tabs
    };
};

export default data;
